<template lang="pug">
  .card
    .card-body
      h4.card-title.text-center.d-flex.justify-content-between
        //- i.fa.fa-chevron-left.sr-only
        i
        span Confirmatory
        i.fa.fa-chevron-right(@click.prevent="next()")
      hr
      p.card-text In conformity with the implementing Rules and Regulations of R.A. 10173, known as the "Data Privacy Act of 2012", that seeks to protect all forms of information, be it private, personal or sensitive. I give my consent the use and collection of my personal data by answering the form
      ValidationObserver(ref="Validation" slim)
        ValidationProvider(name="confirmatory", :rules="{required: {allowFalse: false}}" v-slot="{errors}" slim :customMessages="{required: 'Please read and confirm the agreement.'}")
          div
            .custom-control.custom-checkbox
              input.custom-control-input#confirmatory(type="checkbox" v-model="isChecked")
              label.custom-control-label(:class="{'text-danger': errors.length}" for="confirmatory") I understand that my personal information is protected by RA 10173, the Data Privacy Act of 2012, and that I am required to provide truthful and correct information.
            p.text-danger(v-if="errors.length") {{errors[0]}}
</template>

<style scoped=""></style>

<script>
  import { ref, reactive, watch } from '@vue/composition-api'

  export default {
    name: 'step_1',
    props: {
      value: {
        type: Boolean,
        required: true
      }
    },
    emits: ['next', 'input'],

    setup(props, {emit}) {
      const Validation = ref(null)
      const isChecked = ref(props.value)

      const next = () => {
        emit('next')
      }
      /**
       * [description]
       * @return {[type]} [description]
       */
      const validate = () => {
        emit('input', isChecked.value)
        return Validation.value.validate()
          .then(success => {
            if(success) {
              return Promise.resolve(success)
            }
            return Promise.reject(success)
          })
      }
      watch(() => props.value, (newVal, prevVal) => {
        isChecked.value = newVal
      })
      return {
        Validation,
        next, validate,

        isChecked
      }
    }
  }
</script>